import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowUpRight, Calendar } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { getBlogList, getBlogCategories, fileUrl } from "../api";

const fmt = (d) => {
  try { return new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }); }
  catch { return ""; }
};

const BlogList = () => {
  const navigate = useNavigate();
  const [posts, setPosts] = useState([]);
  const [cats, setCats] = useState([]);
  const [active, setActive] = useState("All");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getBlogCategories().then((c) => setCats(["All", ...c])).catch(() => {});
  }, []);

  useEffect(() => {
    setLoading(true);
    getBlogList(active === "All" ? null : active)
      .then(setPosts)
      .catch(() => setPosts([]))
      .finally(() => setLoading(false));
  }, [active]);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      {/* Hero */}
      <section className="pt-[130px] pb-16" style={{ background: "linear-gradient(135deg,#050C17,#0D1B2A)" }}>
        <div className="pp-container text-center">
          <span className="text-[#10B981] font-semibold uppercase tracking-wider text-sm">PhotonPE Blog</span>
          <h1 className="mt-3 text-4xl md:text-5xl font-extrabold text-white">Insights & Guides</h1>
          <p className="mt-4 text-white/70 max-w-2xl mx-auto">Fintech trends, product guides and payment know-how from the PhotonPE team.</p>
        </div>
      </section>

      <section className="py-14">
        <div className="pp-container">
          {/* Categories */}
          <div className="flex flex-wrap gap-3 justify-center mb-10">
            {cats.map((c) => (
              <button
                key={c}
                onClick={() => setActive(c)}
                className={`px-5 py-2 rounded-full text-sm font-semibold transition-colors ${
                  active === c ? "bg-[#06B6D4] text-white" : "bg-[#F0FDFA] text-[#0D1B2A] hover:bg-[#d9e8f8]"
                }`}
              >
                {c}
              </button>
            ))}
          </div>

          {loading ? (
            <div className="text-center text-[#475569] py-20">Loading articles…</div>
          ) : posts.length === 0 ? (
            <div className="text-center text-[#475569] py-20">No articles yet. Check back soon!</div>
          ) : (
            <div className="grid md:grid-cols-3 gap-7">
              {posts.map((post) => (
                <article
                  key={post.slug}
                  onClick={() => navigate(`/blog/${post.slug}`)}
                  className="group bg-white rounded-3xl overflow-hidden pp-lift border border-slate-100 cursor-pointer"
                >
                  <div className="relative h-52 overflow-hidden">
                    <img src={fileUrl(post.cover_image)} alt={post.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                    <span className="absolute top-4 left-4 bg-[#06B6D4] text-white text-[11px] font-semibold px-3 py-1 rounded-full">{post.category}</span>
                  </div>
                  <div className="p-6">
                    <div className="flex items-center gap-2 text-xs text-[#64748B] mb-2">
                      <Calendar size={13} /> {fmt(post.published_date)} · {post.author}
                    </div>
                    <h3 className="font-bold text-[#0D1B2A] leading-snug group-hover:text-[#0EA5E9] transition-colors line-clamp-2">{post.title}</h3>
                    <p className="mt-2 text-sm text-[#475569] line-clamp-2">{post.excerpt}</p>
                    <span className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-[#0EA5E9]">
                      Read More <ArrowUpRight size={16} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                    </span>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default BlogList;
